"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["JWT"] = "jwt";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
